module.exports = __webpack_public_path__ + "static/media/img_airlines.02ff7434.jpg";